import http from "./http";
import {useRequest} from "ahooks";

let apiPath = {
  getUserPointInfo: '/sys/UdianPointHistory/getUserPointInfo',
  qryUserPointHistoryPage: '/sys/UdianPointHistory/qryUserPointHistoryPage'
};

export const useGetUserPointInfo = () => {
  const { data, runAsync, error, loading } = useRequest((q) => {
    return http({
      url: apiPath.getUserPointInfo,
      method: 'get',
      data: q || {}
    }, { noAlias: true, noAgent: true, token: true });
  }, {
    manual: true,
  });
  
  return {
    result: data,
    loading,
    error,
    getPointInfo: runAsync
  };
};


export const useGetUserPointHistory = () => {
  const { data, runAsync, error, loading } = useRequest((q) => {
    return http({
      url: apiPath.qryUserPointHistoryPage,
      method: 'get',
      data: q || {}
    }, { noAlias: true, noAgent: true, token: true });
  }, {
    manual: true,
  });
  
  return {
    result: data,
    loading,
    error,
    getPointHistory: runAsync
  }
}